const ACTION_TYPES = {
  UPDATE_AISS_NODE_DATA: 'UPDATE_AISS_NODE_DATA',
  UPDATE_EDITOR_DATA: 'UPDATE_EDITOR_DATA',
  SET_STEP_ACTIVE: 'SET_STEP_ACTIVE',
  SET_STEP_TYPE: 'SET_STEP_TYPE',
  SET_STEP_TITLE: 'SET_STEP_TITLE',
  SET_USER_INTENT: 'SET_USER_INTENT',
  SET_FUNCTION_NAME: 'SET_FUNCTION_NAME',
  SET_FUNCTION_DESCRIPTION: 'SET_FUNCTION_DESCRIPTION',
  SET_FUNCTION_PARAMETER: 'SET_FUNCTION_PARAMETER',
  SET_DATA: 'SET_DATA',
  SET_COORDINATE: 'SET_COORDINATE',
  SET_NODE_DATA: 'SET_NODE_DATA',
  RESET_STATE: 'RESET_STATE',
  SET_AISS_NODE_ID: 'SET_AISS_NODE_ID',
  SET_FETCH_DATA_LOADING: 'SET_FETCH_DATA_LOADING',
  SET_ENV_VARIABLES: 'SET_ENV_VARIABLES',
  SET_STEP_AND_FUNCTION_ERRORS: 'SET_STEP_AND_FUNCTION_ERRORS',
  SET_CUSTOM_INSTRUCTIONS: 'SET_CUSTOM_INSTRUCTIONS',
  SET_PII_MASKED_PARAMS: 'SET_PII_MASKED_PARAMS',
};

export default ACTION_TYPES;
